var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sponsor-card external",attrs:{"href":_vm.sponsor.url,"target":"_blank"}},[_c('div',{staticClass:"sponsor-image",style:(_vm.backgroundImage)}),_c('p',{staticClass:"sponsor-label"},[_vm._v(_vm._s(_vm.sponsor.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }